<template>
  <div class="hummer-onboarding">
    <Navbar />
    <Profile v-if="step === 1" @next="goForward" />
    <Team v-if="step === 2" @next="goForward" />
    <TeamContinued v-if="step === 3" @next="goForward" />
    <TeamFocus v-if="step === 4" @next="goForward" />
    <Billing v-if="step === 5" @next="goForward" />
    <Confirmation v-if="step === 6" />
  </div>
</template>

<script>
import Navbar from '../../../components/hummer/onboarding/Navbar/index.vue';
import Profile from './steps/Profile.vue';
import Team from './steps/Team.vue';
import TeamContinued from './steps/TeamContinued.vue';
import TeamFocus from './steps/TeamFocus.vue';
import Billing from './steps/Billing.vue';
import Confirmation from './steps/Confirmation.vue';
import { mapState, mapActions } from 'vuex';

export default {
  components: {
    Navbar,
    Profile,
    Team,
    TeamContinued,
    TeamFocus,
    Billing,
    Confirmation,
  },
  computed: {
    ...mapState('onboarding', ['step']),
  },
  async mounted() {
    document.body.classList.remove('lg:overflow-hidden');
    await this.$store.dispatch('general/loadCurrentUser');
    await this.$store.dispatch('onboarding/loadOnboardingData');

    if (this.$route.query.checkout_id) {
      this.$store.commit('onboarding/setStep', 6);
    }
  },
  methods: {
    ...mapActions('onboarding', ['goForward']),
  },
};
</script>

<style>
@reference "tailwindcss";
.hummer-onboarding .formulate-input:not(.formulate-input-group-item) {
  @apply mb-8;
}

.hummer-onboarding .formulate-input-group-item.formulate-input {
  max-width: 300px;
  margin: 0 auto;
  text-align: left;
}

.hummer-onboarding .formulate-input-group-item.formulate-input {
  margin-bottom: 4px;
}

.hummer-onboarding .formulate-input--google-maps-input input {
  @apply mt-0 mx-auto mb-8;
  max-width: 36rem;
}
</style>
